/* 列傳選單點一章時的「圖解」：交戰雙方、前情、結果與影響（只寫正史；裴注要標出處，演義不放）
 * 鍵是列傳選單上的章節 id（分幕的章寫第一幕）。格式見 src/campaign/bg/index.ts。 */
// @ts-nocheck
export default {
  'luxun-1': {
    sides: [
      { f: 'wu', n: '孫權', l: '陸遜（帳下右部督）', w: 1 },
      { f: 'hj', n: '丹楊山越', l: '費棧（受曹操印綬）' },
    ],
    before: '陸遜二十一歲進孫權幕府，當過海昌屯田都尉，又討平會稽山賊潘臨，手下有了二千多部曲。他向孫權建議：山越盤據深山，是心腹之患，應該大舉收編，取其精銳。這時丹楊賊帥費棧接受曹操的印綬，煽動山越作亂。',
    after: '費棧被擊破。陸遜收編東邊三郡的山越，強壯的編成兵，羸弱的補成民戶，得到精兵數萬人。會稽太守淳于式上表告他擾民，陸遜反而在孫權面前稱讚淳于式是好官。',
    src: '《三國志·吳書·陸遜傳》；〈賀齊傳〉（尤突，建安二十一年）',
  },
  'luxun-2': {
    sides: [
      { f: 'wu', n: '孫權', l: '陸遜、謝旌、李異', w: 1 },
      { f: 'shu', n: '劉備', l: '樊友、詹晏、陳鳳、文布、鄧凱' },
    ],
    before: '建安二十四年，關羽北攻樊城，孫權派呂蒙、陸遜為前部襲取荊州，公安、南郡相繼投降。陸遜一路往西，領宜都太守。劉備的宜都太守樊友棄郡逃走，各城長吏和蠻夷君長都來歸附。',
    after: '陸遜請來金銀銅印，暫授給新歸附的人；謝旌、李異破詹晏，活捉陳鳳；文布、鄧凱戰敗逃走，後來被陸遜誘降。前後斬獲、招納數萬人。陸遜升右護軍、鎮西將軍，封婁侯，屯夷陵守住峽口防備蜀軍。',
    src: '《三國志·吳書·陸遜傳》；〈吳主傳〉',
  },
  'luxun-3': {
    sides: [
      { f: 'wu', n: '孫權', l: '陸遜（大都督）、朱桓、全琮、周魴', w: 1 },
      { f: 'wei', n: '曹叡', l: '曹休、賈逵' },
    ],
    before: '黃武元年陸遜在夷陵火燒劉備連營，此後鎮守西陵。黃武七年，鄱陽太守周魴假裝要投魏，還剪了頭髮向郡府謝罪，騙得曹休相信。曹休率步騎十萬進入皖城，孫權親自執鞭，授陸遜黃鉞，以大都督身分迎擊。',
    after: '曹休發覺上當，仍仗著兵多交戰。陸遜自領中軍，朱桓、全琮為左右翼，三路並進，衝破伏兵，追到夾石，斬獲一萬多人、車乘上萬輛。賈逵帶兵趕到夾石，多設旗鼓當疑兵，吳軍才撤回。曹休回去不久，背上生毒瘡而死。',
    src: '《三國志·吳書·陸遜傳》；〈吳主傳〉〈周魴傳〉〈朱桓傳〉，《魏書》〈曹休傳〉〈賈逵傳〉',
  },
  'luxun-4': {
    sides: [
      { f: 'wu', n: '孫權', l: '陸遜、諸葛瑾', w: 1 },
      { f: 'wei', n: '曹叡', l: '襄陽守軍' },
    ],
    before: '嘉禾三年，孫權親征合肥新城，派陸遜、諸葛瑾進攻襄陽。孫權不久退兵；陸遜派回去送信的親信韓扁又在沔水被魏軍抓走，行軍虛實全被魏軍知道。諸葛瑾很害怕，寫信勸陸遜趕快撤。（〈陸遜傳〉作嘉禾五年，〈吳主傳〉繫在嘉禾三年。）',
    after: '陸遜照樣催人種葑豆、和諸將下棋射箭，接著全軍向襄陽城推進，魏軍趕緊退回城裡；陸遜再整好隊伍慢慢走回船上，魏軍不敢追。撤到白圍後，他又派周峻、張梁偷襲江夏的新市、安陸、石陽，斬殺、俘虜一千多人；裴松之批評這是讓無辜百姓受害。',
    src: '《三國志·吳書·陸遜傳》（含裴松之案語）；〈吳主傳〉',
  },
};
